import React from 'react';
import SharedTranslations, { TranslationField } from "shared/components/Translations";
import { LocaleCode } from "shared/types/languages";
import TranslationInput from "shared/components/Translations/TranslationInput";
import { useFaqGroupDetails } from "../../../../context";
import { ManagedTranslations } from "../../../../context/types";

const Translations = () => {
  const { groupTitle, translations, setTranslations } = useFaqGroupDetails();

  const fields: TranslationField[] = [
    {
      key: ManagedTranslations.GroupName,
      label: "Group Name",
      render: ({ language, value, onChange }) => (
        <TranslationInput
          defaultValue={language === LocaleCode.en ? groupTitle?.input.value : value}
          variant="filled"
          onChange={({ target: { value } }) => {
            if (language === LocaleCode.en) {
              groupTitle?.setValue(value);
            } else {
              onChange(value);
            }
          }}
        />
      ),
    },
  ];

  return (
    <SharedTranslations
      fields={fields}
      translations={translations}
      setTranslations={setTranslations}
    />
  );
};

export default Translations;